import { getComposeEvent, getOriginalEvent } from 'owa-calendar-compose-store-manager';
import { isOriginalTime } from 'owa-calendar-event-capabilities';
import shouldShowFreeBusy from 'owa-calendar-forms-common/lib/utils/shouldShowFreeBusy';
import areAttendeeTypeCollectionsEqual from 'owa-calendar-forms-common/lib/utils/areAttendeeTypeCollectionsEqual';

export default function shouldShowAvailabilityRow(formId: string) {
    const event = getComposeEvent(formId);
    const originalEvent = getOriginalEvent(formId);
    return (
        shouldShowFreeBusy(event) &&
        (event.IsDraft ||
            !isOriginalTime(originalEvent, event) ||
            !areAttendeeTypeCollectionsEqual(
                [...originalEvent.RequiredAttendees, ...originalEvent.OptionalAttendees],
                [...event.RequiredAttendees, ...event.OptionalAttendees]
            ) ||
            !areAttendeeTypeCollectionsEqual(originalEvent.Resources, event.Resources))
    );
}
